import { create } from "zustand";

interface OverweightDialogState {
  /** 배송 상한 초과로 결제가 막혔음을 알리는 모달이 열려 있는가. */
  open: boolean;
  show: () => void;
  hide: () => void;
}

/**
 * **바로구매(PDP)에서 배송 상한 초과를 알리기 위한 전역 상태.**
 *
 * 카트는 인라인 고지로 이유를 상시 보여주지만(수량을 줄이면 풀린다는 것까지), 바로구매는
 * **클릭 후 비동기 조회**로 알게 되고 그 시점에 사용자는 PDP 에 있다 — 화면에 안내를 놓을
 * 자리가 없다. 그래서 모달로 띄운다.
 *
 * 스토어인 이유: `runCheckout` 은 non-hook 이라 상태를 직접 못 만들고, 호출 hook 은
 * PDP·카트 여러 곳에 있다. 모달 자체는 `_app` 이 한 번만 렌더한다(호출처마다 두면
 * lazy mount 에서 silent fail — docs/pitfalls.md "Dialog 내부 useState").
 *
 * `persist` 를 쓰지 않는다 — 세션을 넘겨 기억할 성질이 아니다.
 */
export const useOverweightDialogStore = create<OverweightDialogState>()(
  (set) => ({
    open: false,
    show: () => set({ open: true }),
    hide: () => set({ open: false }),
  }),
);
